import React from 'react'
import moment from 'moment'
import { COLORES } from '../../../../../../config/colores'
import TableValueAction from '../../../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../busquedaCpa/InfoCpa'
import { Tooltip } from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info'

export const COLUMNS_CAMIONES_LISTOS_PARA_BRUTO = [
  {
    name: 'caravana',
    label: ' ',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (c) => !c && (
        <Tooltip title='Descarga silo aparte'>
          <InfoIcon color='action' style={{ fontSize: '1.2rem', cursor: 'help' }} />
        </Tooltip>
      )
    }
  },
  {
    name: 'fechaDeEgresoCalado',
    label: 'Egreso calado',
    options: {
      filter: false,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => fecha ? <>{moment(fecha).format('DD-MM HH:mm')}</> : null
    }
  },
  {
    name: 'numero',
    label: 'Carta de porte',
    options: {
      filter: true,
      sort: true,
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      }),
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      filterList: []
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    options: {
      filter: true,
      sort: true,
      filterList: [],
      filterType: 'checkbox',
      customBodyRender: (v) => {
        return ((v.trim() === 'UNDEF' ? ' - ' : v))
      }
    }
  },
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'titularDeCupo',
    label: 'Titular de cupo',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'remitenteComercial',
    label: 'Remitente comercial',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'corredorComprador',
    label: 'Corredor Vta. Primaria',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'vendedor',
    label: 'Entregador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'camion',
    label: 'Camión',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'humedad',
    label: 'Humedad',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'calificacionCereal',
    label: 'Calificación',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'autodescargable',
    label: 'Autodescargable',
    options: {
      filter: true,
      sort: true,
      display: false,
      filterList: [],
      customBodyRender: autodescargable => {
        return (autodescargable) ? 'Si' : '  '
      }
    }
  },
  {
    name: 'calleDeBruto',
    label: 'Calle de bruto',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
      // display: false
    }
  },
  {
    name: 'fechaAsignacionCalleDeCalado',
    label: 'Asignación calle',
    options: {
      filter: false,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => fecha ? <>{moment(fecha).format('DD-MM HH:mm')}</> : null
    }
  }
]

export const COLUMNS_CAMIONES_LISTOS_PARA_BRUTO_TO_PRINT = [
  {
    name: 'exportador',
    label: 'Exportador',
    width: 90,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fechaDeEgresoCalado',
    label: 'Egreso de calado',
    width: 70,
    mantenerCase: true
  },

  {
    name: 'cartadeporte',
    label: 'Carta de porte',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'titularDeCupo',
    label: 'Titular de cupo',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'corredorVendedor',
    label: 'Corredor',
    width: 90,
    mantenerCase: true
  },
  {
    name: 'vendedor',
    label: 'Vendedor',
    width: 90,
    mantenerCase: true
  },
  {
    name: 'camion',
    label: 'Camión',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'calificacionCereal',
    label: 'Calificacion cereal',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'humedad',
    label: 'Humedad',
    width: 50,
    mantenerCase: true
  }
]
